import { render, staticRenderFns } from "./SuggestOnlyAlertBalance.vue?vue&type=template&id=db1d6ffc&"
import script from "./SuggestOnlyAlertBalance.vue?vue&type=script&lang=js&"
export * from "./SuggestOnlyAlertBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports